module.exports = __webpack_public_path__ + "img/carbonara.2e5e1c8c.jpg";